/**
 * 「免單中獎時，停止開出剩餘獎項」勾選項的純決策函式。DOM 全留給呼叫端，
 * 這裡只回答「該不該顯示勾選區」與「送出時帶哪個欄位」。
 */

/**
 * 勾選區顯不顯示。只認報價的布林 true；轉蛋報價沒有這個鍵，自然排除。
 * @param {?{treasure_stop_available?: boolean}} quote 最新一份報價
 * @returns {boolean}
 */
export function treasureStopOptionVisible(quote) {
    return !!quote && quote.treasure_stop_available === true;
}

/**
 * 送出請求要併入的欄位。勾選區沒顯示就一個欄位都不送——後端把缺席視為全部開完。
 * 顯示時勾選送 '0'（中免單就停）、沒勾選送 '1'（完整開完）。
 * @param {?{treasure_stop_available?: boolean}} quote 最新一份報價
 * @param {boolean} stopOnHit 客人有沒有勾選「停止開出剩餘獎項」
 * @returns {{treasure_open_all?: string}}
 */
export function treasureStopFields(quote, stopOnHit) {
    if (!treasureStopOptionVisible(quote)) {
        return {};
    }

    return { treasure_open_all: stopOnHit ? '0' : '1' };
}
